'use client';

import { SnackbarProvider, closeSnackbar } from "notistack";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { clearNotifcation } from "@/redux/slices/AlertMessageSlice";

export function SnackbarProviderWrapper({ children }) {
  const dispatch = useDispatch();

  const clearNotificationData = () => {
    dispatch(clearNotifcation({ messageToaster: false, toasterType: "", toasterMessage: ""}));
  }

  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={3000}
      action={(snackbarId) => (
        <IconButton
          onClick={() => closeSnackbar(snackbarId)}
          size="small"
          sx={{ color: "#fff" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
      onClose={clearNotificationData}
    >
      {children}
    </SnackbarProvider>
  );
}
